import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'wcg-session-expired-dialog',
  styleUrls: ['./session-expired-dialog.component.scss'],
  templateUrl: './session-expired-dialog.component.html',
  standalone: false,
})
export class SessionExpiredDialogComponent {
  private readonly _dialogRef = inject(
    MatDialogRef<SessionExpiredDialogComponent>,
  );

  logout() {
    this._dialogRef.close(false);
  }
}
